import { render, staticRenderFns } from "./route_mapping.vue?vue&type=template&id=54365b61"
import script from "./route_mapping.vue?vue&type=script&lang=js"
export * from "./route_mapping.vue?vue&type=script&lang=js"
import style0 from "./route_mapping.vue?vue&type=style&index=0&id=54365b61&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports